import {
    CLICK_EVENT,
    CATEGORY_FILTER_NAME,
    REGION_FILTER_NAME,
    JOBTYPE_FILTER_NAME,
    REGION_ZIPCODE_FILTER_NAME,
    FREE_TEXT_FILTER_NAME,
    URL_PARAMS_SEPERATOR,
    WORKPERIOD_FILTER_NAME,
} from './constants';

export default class SelectedFilters {
    constructor({ elm, updateBadges, onChangeFilters, toggleResetFiltersBtn }) {
        this.selectedFiltersContainer = elm?.querySelector(
            '[data-selected-filters]',
        );

        this.selectedFiltersDict = {
            [CATEGORY_FILTER_NAME]: {},
            [REGION_FILTER_NAME]: {},
            [JOBTYPE_FILTER_NAME]: {},
            [WORKPERIOD_FILTER_NAME]: {},
            [FREE_TEXT_FILTER_NAME]: {},
        };

        this.updateBadges = updateBadges;
        this.onChangeFilters = onChangeFilters;
        this.toggleResetFiltersBtn = toggleResetFiltersBtn;
    }

    getFilterByName(filterName) {
        return this.selectedFiltersDict[filterName];
    }

    getValuesCount() {
        return (
            Object.keys(this.selectedFiltersDict[CATEGORY_FILTER_NAME]).length +
            Object.keys(this.selectedFiltersDict[REGION_FILTER_NAME]).length +
            Object.keys(this.selectedFiltersDict[JOBTYPE_FILTER_NAME]).length +
            Object.keys(this.selectedFiltersDict[WORKPERIOD_FILTER_NAME]).length + 
            Object.keys(this.selectedFiltersDict[FREE_TEXT_FILTER_NAME]).length
        );
    }

    getCount(filterName) {
        return Object.values(this.getFilterByName(filterName))?.filter(
            ({ includeInCount }) => includeInCount,
        )?.length;
    }

    getInputNodeById(id, filterName) {
        return this.selectedFiltersDict[filterName][id];
    }

    anySelected() {
        return this.getValuesCount() > 0;
    }

    addCheckmarkInputsToUrlParams(urlParams, filterName) {
        const values = [];
        Object.values(this.selectedFiltersDict[filterName])?.forEach(
            ({ inputNode: { name, id } }) => {
                if (name !== REGION_ZIPCODE_FILTER_NAME) {
                    values.push(id);
                }
            },
        );
        values.length > 0 &&
            urlParams.append(filterName, values.join(URL_PARAMS_SEPERATOR));
    }

    addToSelectedFilters({
        inputNode,
        filterName,
        updateBadge = true,
        includeInCount = true,
        removeKeywordCallback = null,
        fetchQuery = true,
        customSpan = null,
    }) {
        const { id, name, value } = inputNode;
        const wrapper = document.createElement('div');
        const span = customSpan ?? document.createElement('span');

        // custom spans allow specialized content inside keyword div
        if (!customSpan) {
            span.innerHTML = inputNode.type === 'checkbox' ? name : value;
        }
        // add remove listener to the newly added keyword
        wrapper.addEventListener(
            CLICK_EVENT,
            function () {
                this.removeFromSelectedFilters({
                    id,
                    filterName,
                    updateBadge,
                    callback: removeKeywordCallback,
                });
            }.bind(this),
        );

        wrapper.appendChild(span);
        this.selectedFiltersDict[filterName][id] = {
            keywordNode: wrapper,
            innerSpanNode: span,
            inputNode: inputNode,
            includeInCount: includeInCount,
            id: id,
        };
        this.selectedFiltersContainer.appendChild(wrapper);
        if (updateBadge) {
            this.updateBadges(filterName);
        }
        this.onChangeFilters(fetchQuery);
        this.toggleResetFiltersBtn();
    }

    removeFromSelectedFilters({
        id,
        filterName,
        updateBadge = true,
        callback = null,
        fetchQuery = true,
        clearInputValue = true,
    }) {
        try {
            const selectedFilterObj = this.getInputNodeById(id, filterName);
            if (selectedFilterObj) {
                const { keywordNode = null, inputNode = null } =
                    selectedFilterObj;
                this.selectedFiltersContainer.removeChild(keywordNode);
                delete this.selectedFiltersDict[filterName][id];
                if (inputNode.type === 'checkbox') {
                    inputNode.checked = false;
                } else {
                    if (clearInputValue) {
                        inputNode.value = '';
                    }
                }

                if (updateBadge) {
                    this.updateBadges(filterName);
                }
                if (callback) {
                    callback();
                }
                this.onChangeFilters(fetchQuery);
                this.toggleResetFiltersBtn();
            }
        } catch (error) {
            console.warn(error);
        }
    }
}
